// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"402ec1bc","333":"d730ae7e","416":"596f7a04","453":"a38ae4c1","665":"096acec7","870":"8ea4764e","939":"3d9b4dc3"}[chunkId] + ".chunk.js";
};